"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    computed: {
        $axios: function () {
            return this.$store.state.axios;
        }
    }
};
